/**
 * De scheidslijn tussen de agenda en de tabel in 'Huishoudens inplannen'
 * (verzoek BuurtKlusBedrijf 2026-10-01: de planner kiest zelf de verdeling).
 *
 * Puur rekenwerk, los van de muis: zoveel pixels omlaag is zoveel meer aandeel
 * voor de agenda. De grenzen zijn ruimer dan de ondergrenzen in
 * splitAgendaPanes, die winnen altijd; dit houdt alleen de keuze zelf binnen
 * een zinnige band, zodat een doorgeschoten sleep niet op 0 of 1 blijft hangen.
 * AI-CONTEXT: See docs/features/household-agenda-view.md
 */

/** Minder dan een kwart agenda is geen agenda meer. */
const MIN_SHARE = 0.25

/** Meer dan 80% laat van de tabel alleen de koprij over. */
const MAX_SHARE = 0.8

/** De stap van de pijltjestoetsen op de scheidslijn. */
const STEP = 0.05

/**
 * Binnen de band, afgerond op twee decimalen zodat stappen heen en terug
 * weer precies op dezelfde waarde uitkomen (en de opslag leesbaar blijft).
 * @param {number} share
 * @returns {number}
 */
const clampShare = (share) => Math.round(Math.min(MAX_SHARE, Math.max(MIN_SHARE, share)) * 100) / 100

/**
 * @param {object} sleep
 * @param {number} sleep.startShare - Het aandeel toen de sleep begon
 * @param {number} sleep.deltaY - Hoeveel pixels de muis sindsdien omlaag ging (negatief = omhoog)
 * @param {number} sleep.total - De verdeelbare hoogte in pixels (agenda + tabel samen)
 * @returns {number} Het nieuwe aandeel voor de agenda
 */
const shareFromDrag = ({ startShare, deltaY, total }) => {
    if (!(typeof total === 'number' && total > 0)) return startShare
    return clampShare(startShare + deltaY / total)
}

export { MIN_SHARE, MAX_SHARE, STEP, clampShare }
export default shareFromDrag
